"use client";

import { FaLinkedin, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import Link from "next/link";

const navigation = [
  {
    name: "X",
    href: "https://x.com/SalesablyAI",
    icon: (props) => <FaXTwitter {...props} />,
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/channel/UCQNgHj_0eMaAcuUJsEF4p5w",
    icon: (props) => <FaYoutube {...props} />,
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/salesably/posts/?feedView=all",
    icon: (props) => <FaLinkedin {...props} />,
  },
];

const footerLinks = [
  { name: "Privacy Policy", href: "/privacy-policy" },
  { name: "Terms of Service", href: "/terms-of-service" },
  { name: "Contact", href: "https://www.salesably.ai/contact", external: true },
  {
    name: "What's New",
    href: "https://www.salesably.ai/updates",
    external: true,
  },
];

// Deliberately compact (single ~50px row): on short screens the page content
// ends just above the footer, so a tall footer eats a visible slice of the
// working area (SAL-2508). Everything stays, just inline.
export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-y-2 px-6 py-4 text-xs text-gray-500 sm:flex-row sm:justify-between lg:px-8">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
          {footerLinks.map((link) => (
            <Link
              key={link.name}
              href={link.href}
              target={link.external ? "_blank" : undefined}
              rel={link.external ? "noopener noreferrer" : undefined}
              className="transition-colors hover:text-gray-700"
            >
              {link.name}
            </Link>
          ))}
          <span className="flex items-center gap-3">
            {navigation.map((item) => (
              <Link
                key={item.name}
                href={item.href}
                className="text-gray-400 transition-colors hover:text-gray-600"
                target={item.href.startsWith("http") ? "_blank" : undefined}
                rel={
                  item.href.startsWith("http")
                    ? "noopener noreferrer"
                    : undefined
                }
              >
                <span className="sr-only">{item.name}</span>
                <item.icon className="h-4 w-4" aria-hidden="true" />
              </Link>
            ))}
          </span>
        </div>
        <p className="text-center sm:text-right">
          &copy; {new Date().getFullYear()} Salesably · Built with ❤️ for sales
          professionals
        </p>
      </div>
    </footer>
  );
}
